const translations = {
  'accommodation.seo.title':
    'Encuentra alojamiento económico para estudiantes en Barcelona y Sevilla',
  'accommodation.seo.description': `En TEFL Iberia ayudamos a nuestros estudiantes a encontrar alojamiento asequible en Barcelona y Sevilla. Obtén más información sobre cómo podemos ayudarte.`,
  'accommodation.sec1.title': 'Alojamiento',
  'accommodation.sec1.description':
    'Si la idea de mudarte a otra ciudad y tener que negociar con propietarios extranjeros suena estresante, ¡no te preocupes! Ofrecemos un servicio de alojamiento que te <accent>garantiza comodidad, excelente relación </accent> calidad-precio y está ubicado a una distancia accesible de la escuela. Además, nuestro servicio de ubicación de alojamiento es completamente gratuito y opcional.',
};

export default translations;
